import moment from "moment";
import { RRule } from "rrule";

const getRRuleDisplayText = (rruleString: string, startDate = new Date(), timezone?: string) => {
  if (!rruleString) return '';

  try {
    const rule = RRule.fromString(rruleString);
    const freq = rule.options.freq;
    const byweekday = rule.options.byweekday;
    const bysetpos = rule.options.bysetpos;

    const getOrdinal = (num: number): string => {
      const ordinals: Record<number, string> = {
        1: 'first',
        2: 'second',
        3: 'third',
        4: 'fourth',
        5: 'last',
        6: 'last'
      };
      return ordinals[num] || `${num}th`;
    };

    const getDayNameFromStartDate = () => {
      if (timezone) {
        return moment(startDate).tz(timezone).format('dddd');
      }
      return moment(startDate).format('dddd');
    };

    const isWeekdaysOnly = (byweekday: any[]) => {
      return !(!byweekday || byweekday.length !== 5)
    };

    switch (freq) {
      case RRule.DAILY:
        return 'Daily';

      case RRule.WEEKLY:
        if (byweekday) {
          if (isWeekdaysOnly(byweekday)) {
            return 'Daily on weekdays';
          } else if (byweekday.length === 1) {
            const dayName = getDayNameFromStartDate();
            return `Weekly on ${dayName}`;
          } else {
            const dayName = getDayNameFromStartDate();
            return `Weekly on ${dayName}`;
          }
        }
        return 'Weekly';

      case RRule.MONTHLY:
        if (byweekday && byweekday.length === 1 && bysetpos && bysetpos.length === 1) {
          const dayName = getDayNameFromStartDate();
          const ordinal = bysetpos[0] === -1 ? 'last' : getOrdinal(bysetpos[0]);
          return `Monthly on ${ordinal} ${dayName}`;
        } else return 'Monthly';

      case RRule.YEARLY:
        if (startDate) {
          const date = timezone
            ? moment(startDate).tz(timezone).format('MMMM Do')
            : moment(startDate).format('MMMM Do');
          return `Yearly on ${date}`;
        }
        return 'Yearly';

      default:
        return 'Custom recurrence';
    }
  } catch (error) {
    console.error('Error parsing RRULE:', error);
    return 'Custom recurrence';
  }
};

export default getRRuleDisplayText;
